import { Builder } from '@builder.io/react';

import Video from './index';

Builder.registerComponent(Video, {
  name: 'SectionVideo',
  inputs: [
    {
      name: 'url',
      type: 'string'
    },
    {
      name: 'poster',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
      defaultValue:
        'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2Fa7e53e25e9dd4378b28e83697a1d9cca'
    },
    {
      name: 'caption',
      type: 'string'
    },
    {
      name: 'smallButton',
      type: 'boolean'
    },
    {
      name: 'controls',
      type: 'boolean'
    },
    {
      name: 'blackButton',
      type: 'boolean',
      defaultValue: true
    }
  ]
});
